import type { IArticle } from '@pressreader/content-types';

import type { IIssueInfoPageArticle, IssueInfoPageArticleComparator, ZeroColumnArticleGrouper } from '../../types';

const articleComparatorByRateDesc: IssueInfoPageArticleComparator = (
    articleA: IIssueInfoPageArticle,
    articleB: IIssueInfoPageArticle,
): 1 | 0 | -1 => {
    const rateDiff = articleB.rate - articleA.rate;
    if (rateDiff === 0) {
        return 0;
    }
    return rateDiff > 0 ? 1 : -1;
};

const pickZeroColumnRepresentative = (
    representative: IIssueInfoPageArticle,
    article: IIssueInfoPageArticle,
    groupArticleId: IArticle['id'],
): IIssueInfoPageArticle => {
    const isRepresentativePrimaryArticle = representative.id === groupArticleId;
    const isArticleGroupRepresentative = article.id === groupArticleId;

    if (!isRepresentativePrimaryArticle && isArticleGroupRepresentative) {
        return article;
    }

    if (!isRepresentativePrimaryArticle && !isArticleGroupRepresentative && (article.rate ?? 0) > (representative.rate ?? 0)) {
        return article;
    }

    return representative;
};

const groupZeroColumnArticleByPrimaryArticleId: ZeroColumnArticleGrouper = (groups, article, resolveArticleGroupId) => {
    const groupId = resolveArticleGroupId(article);
    const groupRate = article.rate ?? 0;
    const group = groups.get(groupId);

    if (!group) {
        groups.set(groupId, {
            representative: article,
            maxRate: groupRate,
        });
        return groups;
    }

    group.representative = pickZeroColumnRepresentative(group.representative, article, groupId);
    group.maxRate = Math.max(group.maxRate, groupRate);

    return groups;
};

export { articleComparatorByRateDesc, groupZeroColumnArticleByPrimaryArticleId };
